module.exports = __webpack_public_path__ + "static/img/mebg.fcbb5328.png";